import { useEffect, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { TrainingLedger, TrainingLedgerSearchForm } from 'entities/training_ledger'
import { useFetchTrainingLedgerApi } from 'api/training_ledger'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useForm } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditTrainingLedgerForm, NewTrainingLedgerForm } from './training_ledger_form'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { setPageSize } from 'utils/util'
import { Flex } from 'components/shared/flex'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableCell,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { trainingLedgerColumnInfoList, TrainingLedgerTableData } from './training_ledger_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { IoNewspaperOutline } from 'react-icons/io5'
import { SearchConditionView } from 'components/shared/search_drawer'

type Props = {
    history: H.History
}

const TrainingLedgerPage = (props: Props) => {
    const searchForm = useForm<TrainingLedgerSearchForm>({})
    const listApi = useFetchTrainingLedgerApi(searchForm)

    const globalState = useContext(GlobalStateContext)
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const multipleCheckForm = useMultipleCheckForm<TrainingLedger>([])

    const [selectedTrainingLedger, setSelectedTrainingLedger] = useState<TrainingLedger>({})

    const trainingLedgerDisplaySetting = useDisplaySetting(trainingLedgerColumnInfoList(searchForm), 'TrainingLedger')
    useEffect(() => {
        listApi.execute()
        setPageSize('portrait')
    }, [])

    const handleClickRemoveFilter = (key: keyof TrainingLedgerSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <EditTrainingLedgerForm
                show={showEdit}
                trainingLedger={selectedTrainingLedger}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                className="no-print"
                headerTitle="教育研修・技能評価記録台帳"
                left={
                    <>
                        <NewTrainingLedgerForm onComplete={() => listApi.execute()} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
            />
            <ContentBody>
                <Flex style={{ flexGrow: 1 }} justifyContent="space-between">
                    <div>
                        <Link to={'/ledger/training/contents'} style={{ margin: 15 }}>
                            記録一覧
                        </Link>
                    </div>
                    <Flex>
                        <div>
                            <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                        </div>
                    </Flex>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {listApi.response.count.toLocaleString()}件</div>
                </Flex>
                <TableWrapper contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={listApi.response.results} multipleCheckForm={multipleCheckForm} disableList={[]}>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={trainingLedgerDisplaySetting} />
                                <TableCell th align="center">
                                    台帳を表示
                                </TableCell>
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={listApi.loading} columnLength={trainingLedgerDisplaySetting.getColumnLength() + 2}>
                            {listApi.response.results.map((trainingLedger: TrainingLedger) => {
                                return (
                                    <CheckboxTableRow
                                        key={`training-ledger-${trainingLedger.id}`}
                                        item={trainingLedger}
                                        multipleCheckForm={multipleCheckForm}
                                        disableList={[]}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedTrainingLedger(trainingLedger)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <TrainingLedgerTableData trainingLedger={trainingLedger} displaySetting={trainingLedgerDisplaySetting} />
                                        <ActionTableCell
                                            width={100}
                                            action="other"
                                            onClick={() => {
                                                props.history.push(`/ledger/training_ledger?id=${trainingLedger.id}`)
                                            }}
                                        >
                                            <IoNewspaperOutline size={14} />
                                        </ActionTableCell>
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                </TableWrapper>
            </ContentBody>
            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="UserGroup"
            >
                <Button onClick={() => props.history.push(`/ledger/training_ledger?id=${multipleCheckForm.ids().join(',')}`)}>
                    選択した台帳をまとめて印刷
                </Button>
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(TrainingLedgerPage)
